import { configureStore } from '@reduxjs/toolkit';
import addressSlice from './features/addressSlice';
import quoteSlice from './features/quoteSlice';
import reloadSlice from './features/reloadSlice';
import toastSlice from './features/toastSlice';

export default configureStore({
  reducer: {
    reload: reloadSlice,
    toast: toastSlice,
    quote: quoteSlice,
    address: addressSlice,
  },
  devTools: process.env.REACT_APP_STAGE === 'development',
});
